import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import '../../QueuePage.scss'
import QueueStatusBadge from '../../../../components/library/badges/QueueStatusBadge';
import mapper from '../../services/QueueWorkflowStateMapper'
import { TaskStatus } from '../../../vdo-ticket/services/TaskStatus';

const UnassignedQueueTicketStatus = ({ workflowStateIdentifier, ticketStateId }) => {
    const [textKey, setTextKey] = useState(null);
    const [status, setStatus] = useState(TaskStatus.IN_PROGRESS);

    useEffect(() => {
        setTextKey(mapper.mapToUnassignedWorkflowTask(workflowStateIdentifier, ticketStateId))
        setStatus(mapper.mapToUnassignedStatus(workflowStateIdentifier, ticketStateId));
    }, [workflowStateIdentifier])

    
    return (
        <div className='queue-status-badge'>
            {textKey && status &&
                <QueueStatusBadge textKey={textKey} status={status} />
            }
        </div>
    );
}

UnassignedQueueTicketStatus.propTypes = {
    workflowStateIdentifier: PropTypes.string,
    ticketStateId: PropTypes.number
}

export default UnassignedQueueTicketStatus